import { QRCodeLabel } from './QRCodeLabel';
export default QRCodeLabel;